"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharedCodes2 = void 0;
exports.sharedCodes2 = {
    caseUid: "83ffb36c-997b-47a6-8253-25af87a626d7",
    isChargeable: true,
    caseType: "EPIC_EMBEDDED",
    tenantId: {
        uuid: "ABCCCEEA-6193-4575-B90D-C7E657C0B922"
    },
    healthSystemTenantId: {
        uuid: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59"
    },
    guid: {
        uuid: "4140b4f2-1f18-46c3-9d0e-078647057bc5"
    },
    serviceLine: "PATHOLOGY",
    gender: "F",
    dateOfBirth: "2000-04-18",
    age: 22,
    hl7InsurancePayerId: null,
    hl7InsurancePlanId: null,
    cmxInsurancePayerId: "172",
    status: "IN_PROGRESS",
    qaStatus: null,
    autoCancelled: false,
    documentImprovements: [],
    sharedDiagnosisCodes: [
        {
            diagnosis_code: "Z12.4",
            sequence_number: 1,
            evidence: [],
            additionalProperties: {
                id: 6791
            },
            shared: true,
            active: true
        },
        {
            diagnosis_code: "R51.9",
            sequence_number: 2,
            evidence: [],
            additionalProperties: {
                id: 6792
            },
            shared: true,
            active: true
        }
    ],
    errors: [
        {
            field: "invoices",
            message_key: "invoice.claims_edit.invalid",
            message: '{"unacceptable primary diagnosis":"Z12.4"}',
            source: "CLAIMS_EDIT"
        }
    ],
    invoices: [
        {
            type: "assembled",
            guid: "e9cbf157-980e-4f42-8cc5-7671f05a20ac",
            date_of_service: "2023-02-03",
            datetime_of_service: "2023-02-03 00:00:00 EST",
            department_code: "10030010328",
            department: {
                name: "test",
                code: "10030010328"
            },
            patient_type: "",
            billing_location: null,
            billing_area: null,
            division: null,
            facility: null,
            filler_number: {
                number: "PATH_CMX_AUT_016_high_confidence_icd_codes_HB_only-2023-79abba1d378745fb9bb9362061f2b955",
                issuer: "EPIC",
                type: "SPECIMEN_NUMBER"
            },
            billing_provider_name: null,
            billing_provider_number: {
                number: "1521674",
                issuer: "EPIC",
                type: "IDNO"
            },
            ordering_provider_name: null,
            ordering_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            referring_provider_name: null,
            referring_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            performing_provider_name: null,
            performing_provider_number: {
                number: "1521674",
                issuer: "EPIC",
                type: "IDNO"
            },
            transactions: [
                {
                    guid: "8999b6e2-4ca3-4d21-b000-c05a54d1f8c1",
                    sequence_number: 1,
                    source_transaction_id: "S12222459",
                    deleted: false,
                    technical_code: {
                        units: 1.0,
                        code: "31000076",
                        sequence_number: 0,
                        evidence: [],
                        additionalProperties: {
                            id: 1757
                        }
                    },
                    procedure: {
                        procedure_code: "88141",
                        units: 1.0,
                        sequence_number: 0,
                        custom_cpt: false,
                        evidence: [],
                        additionalProperties: {
                            id: 6974
                        }
                    },
                    mapped_procedure: null,
                    modifiers: [],
                    diagnoses: [
                        {
                            diagnosis_code: "Z12.4",
                            sequence_number: 1,
                            evidence: [],
                            additionalProperties: {
                                id: 6791
                            },
                            shared: true,
                            active: true
                        },
                        {
                            diagnosis_code: "R51.9",
                            sequence_number: 2,
                            evidence: [],
                            additionalProperties: {
                                id: 6792
                            },
                            shared: true,
                            active: true
                        }
                    ],
                    fee_schedule: "5000356",
                    place_of_service: "BWH_BWHPCJEN"
                }
            ],
            deleted: false,
            health_plan_id: null,
            billing_provider_type: null,
            ordering_provider_type: null,
            referring_provider_type: null,
            performing_provider_type: null
        }
    ],
    cancelled: false
};
//# sourceMappingURL=shared-codes2.js.map